import React from 'react';

const TakePictureBtn = ({ triggerCamera }) => (
  <div onClick={triggerCamera} className="pic-btn btn" />
);

export default TakePictureBtn
